import React, { FC } from 'react'
import Icon, { IconType } from '../Icon'
import style from './Avatar.module.scss'
import { iconName } from '../Icon/types'
import classnames from 'classnames'

export interface AvatarProps {
  src?: string
  alt?: string
  size?: 'xs' | 'sm' | 'md'
}

const Avatar: FC<AvatarProps> = ({ src, alt = `Local user's avatar`, size = 'md' }) => {

  return <div className={classnames(style['avatar'], {
    [style['avatar__icon--small']]: size === 'sm',
    [style['avatar__icon--extra-small']]: size === 'xs'
  })} data-bdd='avatar-container' >
    <div className={classnames(style['avatar__icon'], {
      [style['avatar__icon--transparent']]: src && alt
    })}>
      {
        src
          ? <img src={src} alt={alt} className={style['avatar__img']} data-bdd='avatar-img' />
          : <Icon name={iconName.user} colour={IconType.colour.tertiary} dataBdd='avatar-icon' />
      }
    </div>
  </div>

}

export default Avatar
